import * as constants from '../constants';

export const requestAdminOrganizationList = () => ({type: constants.ADMIN_ORGANIZATION_LIST_REQUESTED, payload: {}});
export const adminOrganizationListSuccess = (data) => ({type: constants.ADMIN_ORGANIZATION_LIST_SUCCESS, payload: {data}});
export const adminOrganizationListFailure = (error) => ({type: constants.ADMIN_ORGANIZATION_LIST_FAILURE, payload: {error}});
